import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Order = ({color, ...props}: IconProps) => {
    return (
        <svg width="47" height="41" viewBox="0 0 47 41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M39.4833 25.5798C39.9715 25.5764 40.4588 25.6242 40.9367 25.7227V25.5798C40.9333 21.2828 39.2883 17.1438 36.3273 13.9824C33.3664 10.821 29.3056 8.86788 24.9491 8.5098V5.5798H26.4025C26.788 5.5798 27.1577 5.42929 27.4302 5.16138C27.7028 4.89347 27.8559 4.53011 27.8559 4.15123C27.8559 3.77235 27.7028 3.40898 27.4302 3.14108C27.1577 2.87317 26.788 2.72266 26.4025 2.72266H20.5888C20.2034 2.72266 19.8337 2.87317 19.5611 3.14108C19.2886 3.40898 19.1354 3.77235 19.1354 4.15123C19.1354 4.53011 19.2886 4.89347 19.5611 5.16138C19.8337 5.42929 20.2034 5.5798 20.5888 5.5798H22.0423V8.5098C17.6858 8.86788 13.6249 10.821 10.664 13.9824C7.7031 17.1438 6.05806 21.2828 6.05469 25.5798V25.7227C6.53259 25.6242 7.01984 25.5764 7.5081 25.5798H39.4833Z"
                fill={color || "#000"}
            />
            <path
                d="M39.4838 28.5781H7.50869C6.35228 28.5781 5.24323 29.0297 4.42552 29.8334C3.60782 30.6371 3.14844 31.7272 3.14844 32.8638C3.14844 34.0005 3.60782 35.0906 4.42552 35.8943C5.24323 36.698 6.35228 37.1496 7.50869 37.1496H39.4838C40.6403 37.1496 41.7493 36.698 42.567 35.8943C43.3847 35.0906 43.8441 34.0005 43.8441 32.8638C43.8441 31.7272 43.3847 30.6371 42.567 29.8334C41.7493 29.0297 40.6403 28.5781 39.4838 28.5781Z"
                fill={color || "#000"}
            />
        </svg>
    )
}

export default Order
